import _toConsumableArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
// src/hooks/useSortedList.ts
import { useMemo } from "react";
function sortBy(key) {
  return function (optionA, optionB) {
    if (typeof optionA[key] === "string") {
      return (optionA[key] || "").localeCompare(optionB[key] || "");
    }
    if (typeof optionA[key] === "number") {
      if (optionA[key] > optionB[key]) return 1;
      if (optionA[key] < optionB[key]) return -1;
      return 0;
    }
    return 0;
  };
}
function useSortedList(list, key) {
  var sortedList = useMemo(function () {
    return _toConsumableArray(list).sort(sortBy(key));
  }, [list, key]);
  return sortedList;
}
export { sortBy, useSortedList };